import { hot } from 'react-hot-loader';
import styled from 'styled-components';
export { default as fetchData } from './fetchData';
import React, { useEffect } from 'react';
import MetaData from './components/meta-data';
import Header from './components/header';
import Sections from './components/sections';
import Results from './components/results';
import Pagination from './components/pagination';
import {Link, spacingHelper} from '../../@nitty';

const MainContent = styled.div``
const BottomContent = styled.div``

const View = ({ data, location }) => {
  return (
    <>
      <MetaData data={data} />
      <MainContent>
        <Header data={data} />
        <Sections data={data} location={location} />
        <Results data={data} location={location} />
      </MainContent>
      <BottomContent>
        <Pagination data={data} location={location} />
      </BottomContent>
    </>
  );
};

export default hot(module)(View);
